export default __webpack_public_path__ + "static/media/logo.95842d49.svg";